import React from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Paper,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  Home as HomeIcon,
  Chat as ChatIcon,
  AccountBalanceWallet as WalletIcon,
  AccountBalance as BankingIcon,
  Store as MarketIcon,
  Settings as SettingsIcon,
  TokenOutlined as TokenIcon,
} from "@mui/icons-material";
import { useAppSelector, useAppDispatch } from "../../hooks/hooks";
import {
  setCurrentNavigationView,
  setSelectedSettingsTab,
} from "../../redux/uiSlice";

const MOBILE_APP_WIDTH = parseInt(
  process.env.REACT_APP_MOBILE_APP_WIDTH || "500"
);

const StyledBottomNavigation = styled(BottomNavigation)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.divider}`,
}));

interface AppNavigationProps {}

const AppNavigation: React.FC<AppNavigationProps> = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const { currentNavigationView } = useAppSelector((state) => state.ui);
  const { messagingEnabled, mooLoansEnabled } = useAppSelector(
    (state) => state.ui
  );
  const { chainType } = useAppSelector((state) => state.wallet);
  const onBoardingCompleted = useAppSelector(
    (state) => state.user.user?.onBoardingCompleted ?? false
  );

  // Use a more reliable mobile detection that works with Chrome's responsive tools
  const isMobileView = useMediaQuery(`(max-width:${MOBILE_APP_WIDTH}px)`);

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        zIndex: theme.zIndex.appBar,
      }}
    >
      <Paper
        sx={{
          width: "100%",
          maxWidth: MOBILE_APP_WIDTH,
          borderRadius: isMobileView ? 0 : "12px 12px 0 0",
          boxShadow: isMobileView ? "none" : "0 0 20px rgba(0,0,0,0.2)",
          overflow: "hidden",
        }}
        elevation={isMobileView ? 0 : 3}
      >
        <StyledBottomNavigation
          showLabels
          value={currentNavigationView}
          onChange={async (event, newValue) => {
            if (newValue === "settings") {
              dispatch(setSelectedSettingsTab("general"));
            }

            if (newValue === "wallet") {
              // Handle wallet navigation logic here if needed
              // try {
              //   if (chainType === "evm") {
              //     //the user is using the window wallet and has not set up their security token
              //     const provider = new ethers.JsonRpcProvider(
              //       process.env.REACT_APP_POLYGON_RPC_URL ||
              //         "https://polygon-rpc.com/"
              //     );
              //     console.log("Connecting to wallet...");
              //     const pk = combineAndDecryptEVMWalletPrivateKey([
              //       user?.securityTokenA ?? "",
              //       user?.verificationCodeB ?? "",
              //       user?.accessPhraseC ?? "",
              //       user?.identityMarkerD ?? "",
              //     ]);
              //     console.log("Initializing EVM contract...");
              //     await dispatch(
              //       initializeContract({ provider, privateKey: pk })
              //     ).unwrap();
              //   } else {
              //     console.log("Initializing Solana program...");
              //     //await dispatch(initializeSolanaProgram({type: 'browser'})).unwrap();
              //   }
              // } catch (error) {
              //   console.error("Error initializing wallet:", error);
              //   // Handle error, e.g., show a notification or alert
              // }
            }
            // if (newValue === "token") {
            //   await dispatch(fetchAllNftsOwnedByUser());
            // }

            // Update the current navigation view
            dispatch(setCurrentNavigationView(newValue));

            // Fetch gift brands when navigating to the market view
            // if (newValue === "market") {
            //   await dispatch(
            //     fetchGiftBrands({ countryCode: "CA", currentPage: 1 })
            //   );
            // }
          }}
          sx={{
            "& .MuiBottomNavigationAction-root": {
              minWidth: "auto",
              minHeight: 56, // Material Design recommended touch target
              padding: "6px 8px",
              "@media (min-width: 600px)": {
                padding: "8px 12px",
              },
            },
          }}
        >
          <BottomNavigationAction
            label="Home"
            icon={<HomeIcon />}
            value="home"
          />
          {messagingEnabled && (
            <BottomNavigationAction
              label="Chat"
              icon={<ChatIcon />}
              value="chat"
            />
          )}

          {
            <BottomNavigationAction
              label="Wallet"
              icon={<WalletIcon />}
              value="wallet"
            />
          }
          {chainType !== "evm" && (
            <BottomNavigationAction
              label="Bank"
              icon={<BankingIcon />}
              value="banking"
            />
          )}
          {/* {chainType === "evm" ? (
            
          ) : (
            onBoardingCompleted && (
              <BottomNavigationAction
                label="Wallet"
                icon={
                  <SvgIcon
                    component={CowIcon as React.ElementType<SvgIconProps>}
                    viewBox="0 0 64 64"
                  />
                }
                value="wallet"
              />
            )
          )} */}

          <BottomNavigationAction
            label="Market"
            icon={<MarketIcon />}
            value="market"
          />

          {chainType === "evm" && (
            <BottomNavigationAction
              label="NFT"
              icon={<TokenIcon />}
              value="token"
            />
          )}

          <BottomNavigationAction
            label="Settings"
            icon={<SettingsIcon />}
            value="settings"
          />
        </StyledBottomNavigation>
      </Paper>
    </Box>
  );
};

export default AppNavigation;
